"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "@opensea/navigation";
import { useOnChange } from "@opensea/ui-kit/hooks";
import { useRef } from "react";
import { QUERY_PARAM_KEYS } from "@/hooks/query-param/keys";
import { useCategoryQueryParam } from "@/hooks/query-param/use-category-query-param";
import { useCollectionOfferStatusQueryParam } from "@/hooks/query-param/use-collection-offer-status-query-param";
import { useCollectionSlugsQueryParam } from "@/hooks/query-param/use-collection-slugs-query-param";
import { useCurrencyCategoryQueryParam } from "@/hooks/query-param/use-currency-category-query-param";
import { useContractStandardQueryParam } from "@/hooks/query-param/use-editable-collections-contract-type-query-param";
import { useEditableCollectionsStatusQueryParam } from "@/hooks/query-param/use-editable-collections-status-query-param";
import { useEditableCollectionsTypeQueryParam } from "@/hooks/query-param/use-editable-collections-type-query-param";
import { useHasMerchandisingQueryParam } from "@/hooks/query-param/use-has-merchandising-query-param";
import { useHasNftQueryParam } from "@/hooks/query-param/use-has-nft-query-param";
import { useIsVerifiedQueryParam } from "@/hooks/query-param/use-is-verified-query-param";
import { useNumericTraitsQueryParam } from "@/hooks/query-param/use-numeric-traits-query-param";
import { useOfferStatusQueryParam } from "@/hooks/query-param/use-offer-status-query-param";
import { useOfferTypeQueryParam } from "@/hooks/query-param/use-offers-type-query-param";
import { useQuantityOwnedQueryParam } from "@/hooks/query-param/use-quantity-owned-query-param";
import { useScrollToTop } from "@/hooks/use-scroll-to-top";
import { useActivityTypeQueryParam } from "../../hooks/query-param/use-activity-type-query-param";
import { useChainsQueryParam } from "../../hooks/query-param/use-chains-query-param";
import { useCurrencyQueryParam } from "../../hooks/query-param/use-currency-query-param";
import { useMarketQueryParam } from "../../hooks/query-param/use-market-query-param";
import { usePriceQueryParam } from "../../hooks/query-param/use-price-query-param";
import { useRarityQueryParam } from "../../hooks/query-param/use-rarity-query-param";
import { useRelayersQueryParam } from "../../hooks/query-param/use-relayers-query-param";
import { useSearchQueryQueryParam } from "../../hooks/query-param/use-search-query-query-param";
import { useStatusQueryParam } from "../../hooks/query-param/use-status-query-param";
import { useTraitsQueryParam } from "../../hooks/query-param/use-traits-query-param";
import { isFilterApplicable } from "./filter-applicability";
function useSearchFiltersCount() {
  const filters = useSearchFilters();
  return filters.length;
}
export function useHasSearchFilters() {
  const count = useSearchFiltersCount();
  return count > 0;
}
function useSearchFilters() {
  const $ = _c(29);
  const pathname = usePathname();
  const {
    collectionSlugs
  } = useCollectionSlugsQueryParam();
  const {
    statuses
  } = useStatusQueryParam();
  const {
    offerStatuses
  } = useOfferStatusQueryParam();
  const {
    activityTypes
  } = useActivityTypeQueryParam();
  const {
    collectionOfferStatuses
  } = useCollectionOfferStatusQueryParam();
  const {
    traits
  } = useTraitsQueryParam();
  const {
    markets: selectedMarkets
  } = useMarketQueryParam();
  const {
    currency
  } = useCurrencyQueryParam();
  const {
    rarity
  } = useRarityQueryParam();
  const {
    category
  } = useCategoryQueryParam();
  const {
    price
  } = usePriceQueryParam(QUERY_PARAM_KEYS.price);
  const {
    price: floorPrice
  } = usePriceQueryParam(QUERY_PARAM_KEYS.floorPrice);
  const {
    price: topOffer
  } = usePriceQueryParam(QUERY_PARAM_KEYS.topOffer);
  const {
    chains: selectedChains
  } = useChainsQueryParam();
  const {
    relayers
  } = useRelayersQueryParam();
  const {
    numericTraits
  } = useNumericTraitsQueryParam();
  const {
    offerTypes
  } = useOfferTypeQueryParam();
  const {
    searchQuery
  } = useSearchQueryQueryParam();
  const {
    category: currencyCategory
  } = useCurrencyCategoryQueryParam();
  const {
    hasNft
  } = useHasNftQueryParam();
  const {
    isVerified
  } = useIsVerifiedQueryParam();
  const {
    price: marketCap
  } = usePriceQueryParam(QUERY_PARAM_KEYS.marketCap);
  const {
    quantityOwned
  } = useQuantityOwnedQueryParam();
  const {
    type: editableCollectionsType
  } = useEditableCollectionsTypeQueryParam();
  const {
    status: editableCollectionsStatus
  } = useEditableCollectionsStatusQueryParam();
  const {
    contractStandard: editableCollectionsContractStandards
  } = useContractStandardQueryParam();
  const {
    hasMerchandising
  } = useHasMerchandisingQueryParam();
  let t0;
  if ($[0] !== activityTypes || $[1] !== category || $[2] !== collectionOfferStatuses || $[3] !== collectionSlugs || $[4] !== currency || $[5] !== currencyCategory || $[6] !== editableCollectionsContractStandards || $[7] !== editableCollectionsStatus || $[8] !== editableCollectionsType || $[9] !== floorPrice || $[10] !== hasMerchandising || $[11] !== hasNft || $[12] !== isVerified || $[13] !== marketCap || $[14] !== numericTraits || $[15] !== offerStatuses || $[16] !== offerTypes || $[17] !== pathname || $[18] !== price || $[19] !== quantityOwned || $[20] !== rarity || $[21] !== relayers || $[22] !== searchQuery || $[23] !== selectedChains || $[24] !== selectedMarkets || $[25] !== statuses || $[26] !== topOffer || $[27] !== traits) {
    const filteredStatuses = statuses.filter(_temp);
    const filteredCollectionOfferStatuses = collectionOfferStatuses.filter(_temp2);
    const hasRelayerFilter = isFilterApplicable("relayers", pathname) && !relayers.includes("all");
    t0 = [...collectionSlugs, ...filteredStatuses, price, floorPrice, topOffer, category, ...numericTraits, rarity, ...currency, ...selectedMarkets, ...traits, ...activityTypes, ...offerStatuses, ...offerTypes, ...selectedChains, hasRelayerFilter ? relayers : null, ...filteredCollectionOfferStatuses, currencyCategory, marketCap, searchQuery, hasNft, isVerified, quantityOwned, editableCollectionsType, editableCollectionsStatus, editableCollectionsContractStandards, hasMerchandising].filter(Boolean);
    $[0] = activityTypes;
    $[1] = category;
    $[2] = collectionOfferStatuses;
    $[3] = collectionSlugs;
    $[4] = currency;
    $[5] = currencyCategory;
    $[6] = editableCollectionsContractStandards;
    $[7] = editableCollectionsStatus;
    $[8] = editableCollectionsType;
    $[9] = floorPrice;
    $[10] = hasMerchandising;
    $[11] = hasNft;
    $[12] = isVerified;
    $[13] = marketCap;
    $[14] = numericTraits;
    $[15] = offerStatuses;
    $[16] = offerTypes;
    $[17] = pathname;
    $[18] = price;
    $[19] = quantityOwned;
    $[20] = rarity;
    $[21] = relayers;
    $[22] = searchQuery;
    $[23] = selectedChains;
    $[24] = selectedMarkets;
    $[25] = statuses;
    $[26] = topOffer;
    $[27] = traits;
    $[28] = t0;
  } else {
    t0 = $[28];
  }
  const filters = t0;
  return filters;
}
function _temp2(s_0) {
  return s_0 !== "all";
}
function _temp(s) {
  return s !== "all";
}
export function useResetScrollOnSearchPills() {
  const $ = _c(2);
  const scrollToTop = useScrollToTop();
  const scrollTimeoutRef = useRef(null);
  const searchFiltersCount = useSearchFiltersCount();
  let t0;
  if ($[0] !== scrollToTop) {
    t0 = () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
        scrollTimeoutRef.current = null;
      }
      scrollTimeoutRef.current = setTimeout(() => {
        scrollToTop();
      }, 100);
    };
    $[0] = scrollToTop;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useOnChange(searchFiltersCount, t0);
}